'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/notifications/node_modules/core-js/internals/is-pure.js
// module id = 353
// module chunks = 25